import axios from 'axios';

import { DASHBOARD } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const obtenerInformacion = () => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/informacion`);
        await dispatch(changeLoader(false));

        await dispatch({
            type: DASHBOARD.OBTENER,
            payload: res.data.informacion
        });
    } catch (error) {
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}